import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import api from '~/utils/api';
import { EquipmentSuggestion } from '~/hooks/useEquipmentsSuggestion/types';

export async function getEquipamentsSuggestion(
  id_contrato: number,
  qtde_sugestoes: number,
): Promise<EquipmentSuggestion[]> {
  const { data } = await api.get<EquipmentSuggestion[]>(
    '/sugestao_equipamento/',
    { params: { id_contrato, qtde_sugestoes } },
  );

  return data;
}

export function useEquipamentsSuggestion(
  id_contrato: number,
  qtde_sugestoes: number,
  options: UseQueryOptions<EquipmentSuggestion[], unknown> = {},
): UseQueryResult<EquipmentSuggestion[], unknown> {
  const toast = useToast();

  return useQuery<EquipmentSuggestion[], unknown>(
    ['equipamentsSuggestion', id_contrato, qtde_sugestoes],
    () => getEquipamentsSuggestion(id_contrato, qtde_sugestoes),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
